import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';
import { FieldBlock } from './FieldBlock';
import { TextInput } from './TextInput';
import OverlayTrigger from '../../shared/OverlayTrigger/CustomOverlayTrigger';

export class InputFieldBlock extends Component {
  displayErrorMessage() {
    if (this.props.errorMessage) {
      return (
        <span className="">
          {this.props.errorMessage}
        </span>
      );
    }
    return null;
  }

  renderError() {
    const { field } = this.props;
    return (field && field.meta.touched && field.meta.error);
  }

  renderHelpIcon() {
    if (this.props.help) {
      const tooltip = (
        <Tooltip id="tooltip">{this.props.help.props.defaultMessage}</Tooltip>
      );
      return (
        <OverlayTrigger placement="top" overlay={tooltip}>
          <a type="button" className="help-icon" data-toggle="tooltip">
            <span className="fa fa-question-circle" aria-hidden="true"></span>
          </a>
        </OverlayTrigger>);
    }
    return null;
  }

  render() {
    const helpTextKey = 'hlp_' + this.props.id;
    const labelKey = 'label_' + this.props.id;
    const divKey = 'div_' + this.props.id;
    const inputId = this.props.id;
    return (
      <FieldBlock xsSize={this.props.xsSize} mdSize={this.props.mdSize} smSize={this.props.smSize} lgSize={this.props.lgSize} rowClass={this.props.rowClass}>
        <div key={divKey}>
          <FormLabel htmlFor={inputId} key={ labelKey }>
            {this.props.labelText}
          </FormLabel>
          <TextInput
            id={inputId}
            name={inputId}
            type={this.props.type}
            className="form-control"
            field={this.props.field}
            isInlineElement
            ariaDescribedBy={helpTextKey}
            hasHelpText={!!this.props.helpText}
          />
          { this.renderError() &&
            <span when="required" className="invalid-feedback">
              <FormattedMessage {...messages.error.required} />
            </span> }
            { this.displayErrorMessage() }
            { this.renderHelpIcon() }
          {this.props.helpText ?
            <span className="understated small" id={helpTextKey} key={helpTextKey}>
              { this.props.helpText }
            </span> : null}
          {this.props.addtlElements || null}
        </div>
      </FieldBlock>
    );
  }
}

InputFieldBlock.propTypes = {
  id: PropTypes.string,
  labelText: PropTypes.object,
  help: PropTypes.object,
  type: PropTypes.string,
  addtlElements: PropTypes.string,
  onChange: PropTypes.func,
  email: PropTypes.bool,
  helpText: PropTypes.object,
  field: PropTypes.object,
  xsSize: PropTypes.number,
  mdSize: PropTypes.number,
  smSize: PropTypes.number,
  lgSize: PropTypes.number,
  rowClass: PropTypes.string,
  value: PropTypes.string,
  errorMessage: PropTypes.object,
  minValue: PropTypes.number,
};
